// extracted by mini-css-extract-plugin
export default {"top-bar":"SegmentsTopBar_top-bar__buAXD","buttons-container":"SegmentsTopBar_buttons-container__x-wIk"};